import React, { useState, useRef, useMemo } from "react";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import { BASE_URL_CHAT_Image } from "../api/ApiConfig";
import user_pic2 from "../assets/images/profile_img.svg";

export default function MensionUsers({ users = [], text = "", index }) {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const ref = useRef(null);

  const mentionUsers = useMemo(() => {
    const list = [...users];
    if (users.length > 1) {
      list.push({ User_Id: "everyone", FirstName: "Everyone", LastName: "" });
    }
    return list;
  }, [users]);

  const openMention = (e, user) => {
    e.stopPropagation();
    setTarget(e.currentTarget);
    setCurrentUser(user);
    setShow(true);
  };

  const renderMessage = () => {
    const elements = [];
    let key = 0;
    let i = 0;

    while (i < text.length) {
      // Check links first
      const linkMatch = text.slice(i).match(/^https?:\/\/[^\s]+/i);
      if (linkMatch) {
        elements.push(
          <a
            key={key++}
            href={linkMatch[0]}
            target="_blank"
            rel="noopener noreferrer"
            className="chat-link"
          >
            {linkMatch[0]}
          </a>
        );
        i += linkMatch[0].length;
        continue;
      }

      // Check mentions
      if (text[i] === "@") {
        let foundUser = null;
        let matchedText = "";

        for (const user of mentionUsers) {
          const fullName = `${user.FirstName} ${user.LastName}`.trim();
          const slice = text.slice(i + 1, i + 1 + fullName.length);

          if (slice.toLowerCase() === fullName.toLowerCase()) {
            foundUser = user;
            matchedText = fullName;
            break;
          }
        }

        if (foundUser) {
          elements.push(
            <span
              key={key++}
              className="mention"
              style={{ color: "#0d6efd", cursor: "pointer" }}
              onClick={(e) => openMention(e, foundUser)}
            >
              {matchedText}
            </span>
          );
          i += matchedText.length + 1; // +1 for @
          continue;
        } else {
          // No user matched, just render @
          elements.push(<span key={key++}>@</span>);
          i++;
          continue;
        }
      }

      // Normal text
      elements.push(<span key={key++}>{text[i]}</span>);
      i++;
    }

    return elements;
  };

  return (
    <div ref={ref} className="msg-text">
      {renderMessage()}

      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref}
        rootClose
        onHide={() => setShow(false)}
      >
        <Popover id={`mention-popover-${index}`}>
          <Popover.Body>
            <div className="d-flex align-items-center gap-2">
              <img
                src={
                  currentUser?.PhotoPath
                    ? BASE_URL_CHAT_Image + currentUser.PhotoPath
                    : user_pic2
                }
                width={36}
                height={36}
                alt=""
              />
              <strong>
                {currentUser?.FirstName} {currentUser?.LastName}
              </strong>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
}
